/** Classe CSS dont le texte est masqué dans le navigateur, avant tout envoi (Recording, Faits). */
export const MASK_CLASS = 'belvdr-mask'
/** Classe CSS des éléments jamais enregistrés (ni contenu, ni Faits). */
export const BLOCK_CLASS = 'belvdr-block'
